<template>
    <singUp @close="closeEvent"></singUp>
</template>

<script>
    const singUp = ()=> import( '../../common/cognito/SignUp');

    export default {
        name: "userDefine",
        components:{
            singUp
        },
        methods:{
            closeEvent(value) {
                this.$emit('closeStepper', value);
            }
        }
    }
</script>

<style scoped>

</style>